import React from 'react';
import PlaceIcon from '@mui/icons-material/Place';
import InventoryIcon from '@mui/icons-material/Inventory';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import styles from './LandingPageV4.module.css';

const steps = [
  {
    Icon: PlaceIcon,
    title: 'Set your location',
    description: 'Tell us where you are to unlock the right local stores and live inventory.',
  },
  {
    Icon: ShoppingBagIcon,
    title: 'Shop nearby shelves',
    description: 'Compare products, prices, and availability across trusted shops near you.',
  },
  {
    Icon: InventoryIcon,
    title: 'Choose your handoff',
    description: 'Pick up when it suits you or have your order delivered straight to your door.',
  },
];

const HowItWorks = () => (
  <section
    id="how-it-works"
    className={styles.howSection}
    aria-labelledby="how-it-works-title"
  >
    <div className={styles.innerWrapper}>
      <div className={styles.howHeader}>
        <div>
          <p className={styles.sectionEyebrow}>Effortless from the start</p>
          <h2 id="how-it-works-title" className={styles.howTitle}>
            Nearby to yours, in three easy steps.
          </h2>
        </div>
        <p className={styles.howDescription}>
          Quickvee brings local selection and modern convenience into one simple
          shopping experience.
        </p>
      </div>

      <ol className={styles.howGrid}>
        {steps.map(({ Icon, title, description }, index) => (
          <li key={title} className={styles.howCard}>
            <div className={styles.howCardTop}>
              <span className={styles.howStep}>0{index + 1}</span>
              <span className={styles.howIcon}>
                <Icon sx={{ fontSize: 24 }} aria-hidden="true" />
              </span>
            </div>
            <h3 className={styles.howCardTitle}>{title}</h3>
            <p className={styles.howCardText}>{description}</p>
          </li>
        ))}
      </ol>
    </div>
  </section>
);

export default HowItWorks;
